export const countryToNationality = {
  afghanistan: "Afghan",
  albania: "Albanian",
  algeria: "Algerian",
  argentina: "Argentinian",
  australia: "Australian",
  austria: "Austrian",
  bangladesh: "Bangladeshi",
  belgium: "Belgian",
  brazil: "Brazilian",
  bulgaria: "Bulgarian",
  cambodia: "Cambodian",
  canada: "Canadian",
  chile: "Chilean",
  china: "Chinese",
  colombia: "Colombian",
  croatia: "Croatian",
  "czech republic": "Czech",
  denmark: "Danish",
  egypt: "Egyptian",
  england: "English",
  estonia: "Estonian",
  ethiopia: "Ethiopian",
  finland: "Finnish",
  france: "French",
  germany: "German",
  greece: "Greek",
  "hong kong": "Hong Konger",
  hungary: "Hungarian",
  iceland: "Icelandic",
  india: "Indian",
  indonesia: "Indonesian",
  iran: "Iranian",
  iraq: "Iraqi",
  ireland: "Irish",
  israel: "Israeli",
  italy: "Italian",
  japan: "Japanese",
  kenya: "Kenyan",
  "north korea": "North Korean",
  "south korea": "South Korean",
  korea: "South Korean",
  laos: "Laotian",
  latvia: "Latvian",
  lebanon: "Lebanese",
  lithuania: "Lithuanian",
  luxembourg: "Luxembourger",
  malaysia: "Malaysian",
  mexico: "Mexican",
  mongolia: "Mongolian",
  morocco: "Moroccan",
  nepal: "Nepali",
  netherlands: "Dutch",
  "new zealand": "New Zealander",
  nigeria: "Nigerian",
  norway: "Norwegian",
  pakistan: "Pakistani",
  peru: "Peruvian",
  philippines: "Filipino",
  poland: "Polish",
  portugal: "Portuguese",
  qatar: "Qatari",
  romania: "Romanian",
  russia: "Russian",
  "saudi arabia": "Saudi Arabian",
  scotland: "Scottish",
  serbia: "Serbian",
  singapore: "Singaporean",
  slovakia: "Slovak",
  slovenia: "Slovenian",
  africa: "African",
  "south africa": "South African",
  spain: "Spanish",
  "sri lanka": "Sri Lankan",
  sweden: "Swedish",
  switzerland: "Swiss",
  syria: "Syrian",
  taiwan: "Taiwanese",
  thailand: "Thai",
  tunisia: "Tunisian",
  turkey: "Turkish",
  ukraine: "Ukrainian",
  "united arab emirates": "Emirati",
  "united kingdom": "British",
  "united states": "American",
  uruguay: "Uruguayan",
  venezuela: "Venezuelan",
  vietnam: "Vietnamese",
  wales: "Welsh",
  yemen: "Yemeni",
  zimbabwe: "Zimbabwean",
};

// Reverse mapping: nationality to country
// For multiple countries with same nationality, we prefer the most common one
export const nationalityToCountry = {
  Afghan: "afghanistan",
  Albanian: "albania",
  Algerian: "algeria",
  Argentinian: "argentina",
  Australian: "australia",
  Austrian: "austria",
  Bangladeshi: "bangladesh",
  Belgian: "belgium",
  Brazilian: "brazil",
  Bulgarian: "bulgaria",
  Cambodian: "cambodia",
  Canadian: "canada",
  Chilean: "chile",
  Chinese: "china",
  Colombian: "colombia",
  Croatian: "croatia",
  Czech: "czech republic",
  Danish: "denmark",
  Egyptian: "egypt",
  English: "england",
  Estonian: "estonia",
  Ethiopian: "ethiopia",
  Finnish: "finland",
  French: "france",
  German: "germany",
  Greek: "greece",
  "Hong Konger": "hong kong",
  Hungarian: "hungary",
  Icelandic: "iceland",
  Indian: "india",
  Indonesian: "indonesia",
  Iranian: "iran",
  Iraqi: "iraq",
  Irish: "ireland",
  Israeli: "israel",
  Italian: "italy",
  Japanese: "japan",
  Kenyan: "kenya",
  "North Korean": "north korea",
  "South Korean": "south korea",
  Laotian: "laos",
  Latvian: "latvia",
  Lebanese: "lebanon",
  Lithuanian: "lithuania",
  Luxembourger: "luxembourg",
  Malaysian: "malaysia",
  Mexican: "mexico",
  Mongolian: "mongolia",
  Moroccan: "morocco",
  Nepali: "nepal",
  Dutch: "netherlands",
  "New Zealander": "new zealand",
  Nigerian: "nigeria",
  Norwegian: "norway",
  Pakistani: "pakistan",
  Peruvian: "peru",
  Filipino: "philippines",
  Polish: "poland",
  Portuguese: "portugal",
  Qatari: "qatar",
  Romanian: "romania",
  Russian: "russia",
  "Saudi Arabian": "saudi arabia",
  Scottish: "scotland",
  Serbian: "serbia",
  Singaporean: "singapore",
  Slovak: "slovakia",
  Slovenian: "slovenia",
  African: "africa",
  "South African": "south africa",
  Spanish: "spain",
  "Sri Lankan": "sri lanka",
  Swedish: "sweden",
  Swiss: "switzerland",
  Syrian: "syria",
  Taiwanese: "taiwan",
  Thai: "thailand",
  Tunisian: "tunisia",
  Turkish: "turkey",
  Ukrainian: "ukraine",
  Emirati: "united arab emirates",
  British: "united kingdom",
  American: "united states",
  Uruguayan: "uruguay",
  Venezuelan: "venezuela",
  Vietnamese: "vietnam",
  Welsh: "wales",
  Yemeni: "yemen",
  Zimbabwean: "zimbabwe",
};
